import { render } from "./Speaker.vue?vue&type=template&id=337545ac&scoped=true"
import script from "./Speaker.vue?vue&type=script&lang=ts"
export * from "./Speaker.vue?vue&type=script&lang=ts"

import "./Speaker.vue?vue&type=style&index=0&id=337545ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-337545ac"

export default script